// Third-party
import React from 'react';

// Namespaces
import * as ProposalNS from '../../../Proposal';

// Components
import { FormattedMessage } from '../../../../../utils/i18n';
import { PatternSelector } from '@/views/components/misc';
import { Typography } from '@capintel/component-lib/typography';

// Utils
import { PROPOSAL_PATTERN } from '../../../utils/constants';
import { ALLOWED_HTML_TAGS } from '@/views/components/i18n/FormattedMessageV2';

type Props = {
  onHeaderPatternChange?: (pattern: string) => void;
  styleOptions: ProposalNS.ProposalStyleOptionsV2;
};

const ProposalPatternSelector: React.FunctionComponent<Props> = ({ onHeaderPatternChange, styleOptions }: Props) => {
  if (!styleOptions || !styleOptions.banners) {
    return null;
  }

  return (
    <div className="proposal-option">
      <Typography as={ALLOWED_HTML_TAGS.H2} variant="headerXs">
        <FormattedMessage id="Proposal.Tabs.Options.HeaderPattern" />
      </Typography>
      <PatternSelector patterns={Object.keys(PROPOSAL_PATTERN)} onChange={onHeaderPatternChange} selected={styleOptions.banners.pattern} />
    </div>
  );
};

export default ProposalPatternSelector;
